import React, { useEffect } from 'react';

import useIsMobile from 'hooks/useIsMobile';
import useIsLandscape from 'hooks/useIsLandscape';

import RotateDeviceImage from 'assets/images/icons/rotate-screen.svg';
import DeviceImage from 'assets/images/icons/devices.svg';
import useStore from 'state/state';

import Logo from 'assets/images/axelent-logo-bright.svg';

import styles from './DeviceWarningOverlay.module.scss';

const DeviceWarningOverlay = () => {
  const isMobile = useIsMobile();
  const isLandscape = useIsLandscape();
  const appData = useStore((state) => state.appData);

  const isVisible = isMobile || !isLandscape;
  useEffect(() => {}, [isMobile, isLandscape]);
  if (!isVisible) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        {!isLandscape && !isMobile && <RotateDeviceImage />}
        {isMobile && !isLandscape && <DeviceImage />}
        {isMobile && isLandscape && <DeviceImage />}
        {appData && (
          <>
            {!isLandscape && !isMobile && (
              <h3 className={styles.title}>
                {appData.mainData.overallApp.rotateScreenHeaderText}
              </h3>
            )}
            {isLandscape && !isMobile && (
              <h4 className={styles.title}>
                {' '}
                {appData.mainData.overallApp.useBiggerScreenHeaderText}
              </h4>
            )}
            {isLandscape && isMobile && (
              <h4 className={styles.title}>
                {' '}
                {appData.mainData.overallApp.useBiggerScreenHeaderText}
              </h4>
            )}
            {!isLandscape && !isMobile && (
              <p className={styles.text}>
                {' '}
                {appData.mainData.overallApp.rotateScreenDescriptionText}
              </p>
            )}
            {isLandscape && !isMobile && (
              <p className={styles.text}>
                {' '}
                {appData.mainData.overallApp.useBiggerScreenDescriptionText}
              </p>
            )}
            {isLandscape && isMobile && (
              <p className={styles.text}>
                {' '}
                {appData.mainData.overallApp.useBiggerScreenDescriptionText}
              </p>
            )}
          </>
        )}
      </div>
      <div className={styles.logo}>
        <Logo />
      </div>
    </div>
  );
};

DeviceWarningOverlay.propTypes = {};

export default DeviceWarningOverlay;
